import { Dictionary } from '../Application';
var ModalFactory = (function () {
    function ModalFactory() {
        this.factories = new Dictionary();
    }
    ModalFactory.prototype.create = function (type) {
        var modal = this.factories.value(type);
        if (modal) {
            return modal;
        }
        return null;
    };
    ModalFactory.prototype.register = function (modal) {
        this.factories.add(modal.name(), modal);
    };
    return ModalFactory;
}());
export { ModalFactory };
